import { IEmsAgency } from "@/Login/services";

export interface IUser {
  id?: string;
  firstName?: String;
  lastName?: String;
  displayName: string;
  email?: string;
  emsAgenciesAdministered?: Array<IEmsAgency>;
  emsAgencyMemberships?: Array<IEmsAgency>;
  isAdmin?: boolean;
  roles?: Array<string>;
  username: string;
}

export function getUsersEmsAgencies(user: IUser): Array<IEmsAgency> {
  const allEmsAgencies = uniqBy([...(user.emsAgenciesAdministered || []), ...(user.emsAgencyMemberships || [])], "id");
  const emsAgencies = allEmsAgencies
    .map(agency => {
      if ((user.emsAgenciesAdministered || []).find(a => a.id === agency.id) || user.isAdmin) {
        return { ...agency, admin: true } as IEmsAgency;
      } else {
        if (agency.supportedFeatures.find(f => f.name === "allowEmsMembersToSeeCases" && f.enabled === true)) {
          return { ...agency, admin: false } as IEmsAgency;
        } else {
          return null;
        }
      }
    })
    .filter(agency => agency !== null);
  return emsAgencies;
}

function uniqBy(array, field) {
  const ids = array.map(object => object[field]);
  return array.filter((object, index) => !ids.includes(object[field], index + 1));
}
